import React from 'react';
import { Phone } from 'lucide-react';
import { businessInfo } from '../data/mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black border-t border-gray-800 relative overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute bottom-0 left-1/4 w-96 h-96 bg-purple-600 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-pink-600 rounded-full filter blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Logo & About */}
          <div className="md:col-span-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_bilservice-gavle/artifacts/2ug1w9wo_GADEP-Picsart-BackgroundRemover.jpg" 
              alt="Gävles Autodepå" 
              className="h-20 w-auto mb-6"
            />
            <p className="text-gray-400 leading-relaxed mb-6">
              Din lokala bilverkstad i Gävle. Vi erbjuder professionell service, reparation och underhåll 
              med fokus på kvalitet och kundnöjdhet.
            </p>
            <a 
              href={`tel:${businessInfo.phone}`}
              className="inline-flex items-center gap-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white px-6 py-3 rounded-lg font-semibold hover:from-purple-700 hover:to-pink-700 transition-all duration-300 shadow-lg shadow-purple-500/30"
            >
              <Phone size={20} />
              {businessInfo.phone}
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Snabblänkar</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-purple-400 transition-colors duration-300">
                  Tjänster
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-purple-400 transition-colors duration-300">
                  Om Oss
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('process')} className="text-gray-400 hover:text-purple-400 transition-colors duration-300">
                  Så Fungerar Det
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('reviews')} className="text-gray-400 hover:text-purple-400 transition-colors duration-300">
                  Recensioner
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-purple-400 transition-colors duration-300">
                  Kontakt
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Kontakt</h3>
            <ul className="space-y-3 text-gray-400">
              <li>
                <div className="font-semibold text-white mb-1">Adress</div>
                {businessInfo.address.street}<br />
                {businessInfo.address.postal}
              </li>
              <li>
                <div className="font-semibold text-white mb-1">Telefon</div>
                <a href={`tel:${businessInfo.phone}`} className="hover:text-purple-400 transition-colors">
                  {businessInfo.phone}
                </a>
              </li>
              <li>
                <div className="font-semibold text-white mb-1">E-post</div>
                <a href={`mailto:${businessInfo.email}`} className="hover:text-purple-400 transition-colors break-all">
                  {businessInfo.email}
                </a>
              </li>
              <li>
                <div className="font-semibold text-white mb-1">Öppettider</div>
                Mån-Fre: 08–18<br />
                Lör-Sön: Stängt
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {currentYear} Gävles Autodepå. Alla rättigheter förbehållna.
          </p>
          <div className="flex items-center gap-6 text-sm text-gray-500">
            <button className="hover:text-purple-400 transition-colors duration-300">Integritetspolicy</button>
            <button className="hover:text-purple-400 transition-colors duration-300">Villkor</button>
          </div>
        </div>
      </div>
    </footer>
  );
};
